(function () {
    angular
        .module('appback')
        .directive('ngRazas', razas);

    razas.$inject = ['$timeout', 'GenerallabService'];
    function razas($timeout, GenerallabService) {
        return {
            //require: 'ngModel',
            templateUrl: '/backend/resultadopeticion/template?name=razas.twig',
            scope: {
                //ngModel : '=',
                item: '=',
                animal: '=',
                sub: '='
            },
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                    scope.generalLab = GenerallabService;
                    if (!scope.item.resultado) {
                        scope.item.resultado = { extra: { resultado: {} } };
                    } else {
                        if (!scope.item.resultado.extra) {
                            scope.item.resultado.extra = { resultado: {} };
                        } else {
                            if (!scope.item.resultado.extra.resultado) {
                                scope.item.resultado.extra.resultado = {};
                            } else {
                                // if (Array.isArray(scope.item.resultado.extra.resultado)) {
                                //     scope.item.resultado.extra.resultado = {};
                                // }
                            }
                        }
                    }

                });
            }
        }
    }
})();